export default "__VITE_ASSET__Bol$wSLJ__"